export const ENTITY_FIELD_SLOT_WIDTH = 28;
export const ENTITY_FIELD_SLOT_WIDTH_IN_PX = `${ENTITY_FIELD_SLOT_WIDTH}px`;

export const ENTITY_FIELD_HEIGHT = 28;
export const ENTITY_FIELD_HEIGHT_IN_PX = `${ENTITY_FIELD_HEIGHT}px`;
